<script>
import { ListBox } from "carbon-components-svelte";

  const other = [
    {
      img: 'slideshow/creditverathaler.jpg',
      h2: 'Slack',
      h22: 'Line',
      p: 'Started by climbers, slacklineing is a sport where you walk on thin webbing and develop your core and balance skills. ',
    },

    // {img:'slideshow/nav.jpeg', url:'#' ,alt:'',effect:'sadie',h2:'Nav',h22:'',p:''},
    {
      img: 'slideshow/sup.jpeg',
      h2: 'Stand Up',
      h22: 'PaddleBoard',
      p: 'A type of paddling often done on a rigid or inflatable board. ',
    },
    {
      img: 'slideshow/ws.jpg',
      h2: 'Wind',
      h22: 'SURF',
      p: '',
    },
    {
      img: 'slideshow/climb_corvus.jpeg',
      h2: 'Trad',
      h22: 'Climb',
      p: 'Traditional Climbing is a type of climing where you add your own protection as you head up a wall.',
    },
    {
      img: 'slideshow/yacht.jpg',
      h2: 'Yachting',
      h22: '',
      p: '',
    },
    {
      img: 'slideshow/cycle.jpeg',
      h2: 'Road',
      h22: 'Cycling',
      p: '',
    },

    /// winter skills
    /// scrambling
  ];
</script>

<section class="portfolio text-center section-padding" id="portfolio">
  <div class="container">
    <div class="row">

            {#each other as bx}
            <div class="col-md-4 wp4">
              <div class="overlay-effect effects clearfix">
                <div class="img">
                  <img src="{bx.img}" alt="Portfolio Item" />
                  <!-- <div class="overlay">
                    <a href="#" class="expand"
                      ><i class="fa fa-search" /><br />View More</a
                    >
                    <a class="close-overlay hidden">x</a>
                  </div> -->
                </div>
              </div>

              <h2>{bx.h2}{bx.h22}</h2>
              <p>
                {bx.p}
              </p>
            </div>
            {/each}
     
    </div>
  </div>
</section>

<style>
    row{
  justify-content: center;
  filter:invert(1);


  row-gap: 10px;
  column-gap: 20px;
    }
    img {
    /* width: 30vw;
    max-height: 20vw!important;
    height: auto;       */
}
</style>
